<div >
    <div class="modal-header att-modal-header">
      <h4 class="att-modal-tittle">Attach</h4>
    </div>
    <div class="modal-body att-modal-body">
          <kendo-upload 
          [saveUrl]="uploadSaveUrl"
          [removeUrl]="uploadRemoveUrl"
          [autoUpload]="true"
          (select)="onSelectEvent($event)"
          [withCredentials]="false">
          </kendo-upload>
          <!-- <div *ngFor="let selected of fileAttachment">
              <div class="row att-modal-row">
                  <div class="col-md-11 att-modal-md11">
                  <h5 class="comment att-modal-comment">{{selected.InvoiceId}} - {{selected.RawFileName}}</h5>
                  </div>
                  <div class="col-md-1 att-modal-md1">
                  <span class="mdi mdi-delete-forever att-modal-remove" data-inline="false" (click)="removeSelectedFile(selected)"></span>
                  </div>
              </div>
          </div> -->
    </div>
    <div class="modal-footer att-modal-footer">
    <button type="button" class="btn btn-info btn-secondary btn-modal-footer-x" (click)="dismiss()">Cancel</button>
    </div>
</div>

